import axios from 'axios';
const moment = require('moment');
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    bankaccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/bankcashacc/allaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    // byrsemu(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const {
    //                 data
    //             } = await axios.get(`arinv/byrsemu/${obj.arinvKey}`);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 
                    'status', 'nomor', 'nasabahkey', 'customer', 'kodebank', 'namabank', 'reference', 'no_kontrak', 'tgldue1', 'tgldue2', 'unearned', 'collector_id','optiondate','poststatus'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/payment${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    pinjamanPrepaid(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 
                'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 
                'nasabahkey', 'customer', 'kodebank', 'namabank', 
                'reference', 'tgldue1', 'tgldue2', 'unearned', 
                'collector_id', 'no_agreement', 'no_kontrak', 'CustName', 
                'CustCode', 'vanumber','isrrd','pinjamankeynotin'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/payment/pinjaman-prepaid${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    pinjamanPrepaidWithInstallment(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'nomor', 'customer', 'CustCode', 'tgl1', 'tgl2', 'collector_id'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/payment/pinjaman-prepaid-with-installment${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    paymenthistory(nasabahkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/payment/payment-history/${nasabahkey}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    arpaymdetail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`payment/arpaymdetail/${obj.arpaymKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    insert(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("payment", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    insert2trx(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post("payment/save2trxbank", data);
                resolve(resp.data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`payment/${obj.arpaymKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    potongan() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/payment/potongan");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.arpaymKey);
                url = `/payment/printjv`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportXls(obj = {}) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'kodebank', 'namabank', 'reference', 'tgldue1', 'tgldue2', 'unearned', 'collector_id'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/payment/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'debitur_payment.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },

    exportXlsSettlement(obj = {}) {
        return new Promise(async (resolve, reject) => {

            try {
                
                const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 
                    'status', 'nomor', 'nasabahkey', 'customer', 'kodebank', 'namabank', 'reference', 'no_kontrak', 'tgldue1', 'tgldue2', 'unearned', 'collector_id','optiondate','poststatus'];
                
    
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                axios({
                    url: `/payment/exportxlsSettlement${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `settlement_by_collection_${moment().format('YYYYMMDDhmmss')}.xlsx`);
                    resolve(true)
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                });
                
            } catch (error) {
                errorHandler(error, reject)
            }

        });

    },

    exportxlsPrepaid(obj = {}) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'nomor', 'customer', 'CustCode', 'tgl1', 'tgl2', 'collector_id'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/payment/exportxlsPrepaid${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'prepaid_payment.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },

    listwithlines(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'nasabahkey', 'customer', 'kodebank', 'namabank', 'reference', 'tgldue1', 'tgldue2', 'unearned', 'collector_id', 'no_kontrak'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                // const url = `/payment/listwithlines${str}`;
                const url = `/payment/vw_fin_arpaymtt_withlines${str}`;
                const { data } = await axios.get(url);
                //console.log("#data: ", data);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportwithlines(obj = {}) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'nasabahkey', 'customer', 'kodebank', 'namabank', 'reference', 'tgldue1', 'tgldue2', 'unearned', 'collector_id', 'no_kontrak'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/payment/exportwithlines${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'debitur_payment_with_lines.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });

    },
    listpbb(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'nasabahkey', 'customer', 'kodebank', 'namabank', 'reference', 'tgldue1', 'tgldue2', 'unearned', 'collector_id'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/payment/listpbb${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    postingbulktrx(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post("payment/postingbulktrx", data);
                resolve(resp.data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    unpostingbulktrx(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post("payment/unpostingbulktrx", data);
                resolve(resp.data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingtrx(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("payment/postingtrx", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    unpostingtrx(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("payment/unpostingtrx", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    getpaymentandallocationprepaidhistory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'pinjamankey','tgl1','tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`payment/payment-and-allocation-prepaid-history${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    getprepaidhistory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'pinjamankey','tgl1','tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`payment/prepaid-history${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
};